module.exports = __webpack_public_path__ + "static/media/16UNODC37.1286ce11.jpg";